import { Button, Navbar, Modal } from "react-bootstrap";
import { useState, useContext } from "react";
import { CartContext } from "../CartContext";
import CartProduct from "./CartProduct";

function NavbarComponent() {
  const cart = useContext(CartContext);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const checkout = async () => {
    // await fetch("http://localhost:4000/checkout", {
    await fetch("https://store-api.woodcashbox.com/checkout", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: cart.items }),
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response.url) {
          window.location.assign(response.url); // Forwarding user to Stripe
        }
      });
  };

  const productsCount = cart.items.reduce(
    (sum, product) => sum + product.quantity,
    0
  );

  return (
    <>
      <Navbar expand="sm mb-4">
        <Navbar.Brand
          href="/"
          style={{ color: "#0d1b2a", fontSize: "30px", fontWeight: "bold" }}
        >
          Cash Box Store
        </Navbar.Brand>
        <Navbar.Toggle />
        <Navbar.Collapse className="justify-content-end">
          <Button
            style={{ backgroundColor: "#0d1b2a", color: "white", border: "none" }}
            onClick={handleShow}
          >
            Cart ({productsCount} Items)
          </Button>
        </Navbar.Collapse>
      </Navbar>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Cart</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "0" }}>
          {productsCount > 0 ? (
            <div>
              <div
                style={{
                  padding: "20px 20px 15px",
                  borderBottom: "1px solid #e9ecef",
                }}
              >
                <h5
                  style={{
                    fontSize: "1.1rem",
                    fontWeight: "600",
                    color: "#0d1b2a",
                    margin: 0,
                  }}
                >
                  Shopping Cart ({productsCount} {productsCount === 1 ? "item" : "items"})
                </h5>
              </div>

              <div
                style={{
                  maxHeight: "400px",
                  overflowY: "auto",
                  padding: "15px 20px",
                }}
              >
                {cart.items.map((currentProduct, idx) => (
                  <CartProduct
                    key={idx}
                    id={currentProduct.id}
                    quantity={currentProduct.quantity}
                  ></CartProduct>
                ))}
              </div>

              <div
                style={{
                  padding: "20px",
                  borderTop: "2px solid #e9ecef",
                  background: "#f8f9fa",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "1.1rem",
                      fontWeight: "600",
                      color: "#6c757d",
                    }}
                  >
                    Total:
                  </span>
                  <span
                    style={{
                      fontSize: "1.5rem",
                      fontWeight: "700",
                      color: "#0d1b2a",
                    }}
                  >
                    ${cart.getTotalCost().toFixed(2)}
                  </span>
                </div>

                <Button
                  style={{
                    backgroundColor: "#28a745",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    padding: "12px 30px",
                    fontSize: "1rem",
                    fontWeight: "500",
                    width: "100%",
                    transition: "all 0.2s ease",
                  }}
                  onClick={checkout}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#218838";
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 4px 8px rgba(40, 167, 69, 0.3)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#28a745";
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  Proceed to Checkout
                </Button>
              </div>
            </div>
          ) : (
            <div
              style={{
                textAlign: "center",
                padding: "40px 20px",
              }}
            >
              <div
                style={{
                  fontSize: "4rem",
                  marginBottom: "20px",
                  color: "#6c757d",
                  opacity: 0.5,
                }}
              >
                🛒
              </div>
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  color: "#0d1b2a",
                  marginBottom: "10px",
                }}
              >
                Your cart is empty
              </h3>
              <p
                style={{
                  fontSize: "1rem",
                  color: "#6c757d",
                  marginBottom: "30px",
                  lineHeight: "1.6",
                }}
              >
                Start adding items to your cart to see them here.
              </p>
              <Button
                style={{
                  backgroundColor: "#0d1b2a",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  padding: "12px 30px",
                  fontSize: "1rem",
                  fontWeight: "500",
                  transition: "all 0.2s ease",
                }}
                onClick={() => {
                  handleClose();
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#1a2f4a";
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 8px rgba(13, 27, 42, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#0d1b2a";
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                Continue Shopping
              </Button>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default NavbarComponent;
